module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AzSKbL/tc-custom/9781398492639.jpg?1705541169489",
      "alt": "This image is the cover for the book The Glimmering Isle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Glimmering Isle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Rusty isn’t like the other creatures, and they don’t let him forget it. ------------------------- Mocked and mistreated he longs for adventure, but when his wish is fulfilled, he soon realises it’s nothing like he imagined. When his parents are mysteriously kidnapped during a freak summer storm, he’s forced to leave everything he’s ever known to find them. Along the way he uncovers secrets about their past and is dragged into a distant conflict that could have consequences for the whole of the Oakenwood. A tale about fitting in, the value of friends and the secrets of everyday people, The Glimmering Isle is the first book in the Oakenwood series.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sebastian Powers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in a former mining village in Leicestershire, Sebastian has spent time living in France and Spain as well as in Yorkshire and Kent. Sebastian is now settled in Oxford with his French wife Guenièvre. A linguist and social scientist by training, he is happiest when surrounded by nature, whether in nearby woodland or on a hike further afield. His writing is influenced by his love of the countryside and the classic adventure stories he enjoyed as a child.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0